<div class="section">
  <div class="title">Статистика по игрокам в турнире</div>
  <div class="panel" *ngIf="usersStatistic">
    <ng-container *ngIf="isGroupedStatistic()">
      <mtg-statistic-table-grouped
        [statistic]="usersStatistic"
        [sport]="league.sport"
        [teamLogoVisible]="false"
        [sortByForward]="league.sport.isHockey() ? 'rating' : null"
        [sortByDefender]="league.sport.isHockey() ? 'rating' : null"
        [checkNewbie]="!league.sport.isHockey()"
        identity="leaguePlayer"
      ></mtg-statistic-table-grouped>
    </ng-container>
    <mtg-statistic-table
      *ngIf="!isGroupedStatistic()"
      title="Игроки"
      [statisticHeader]="getStatisticHeader()"
      [statistic]="usersStatistic"
      [teamLogoVisible]="false"
      identity="leaguePlayer"
      sort="points"
      order="desc"
    ></mtg-statistic-table>
  </div>
</div>
<div class="section" *ngIf="usersDeclaimedStatistic && usersDeclaimedStatistic.length > 0">
  <div class="title">Отзаявленные игроки</div>
  <div class="panel">
    <ng-container *ngIf="isGroupedStatistic()">
      <mtg-statistic-table-grouped
        [statistic]="usersDeclaimedStatistic"
        [sport]="league.sport"
        [teamLogoVisible]="false"
        [sortByForward]="league.sport.isHockey() ? 'rating' : null"
        [sortByDefender]="league.sport.isHockey() ? 'rating' : null"
        [checkNewbie]="!league.sport.isHockey()"
        identity="leaguePlayer"
      ></mtg-statistic-table-grouped>
    </ng-container>
    <mtg-statistic-table
      *ngIf="!isGroupedStatistic()"
      title="Игроки"
      [statisticHeader]="getStatisticHeader()"
      [statistic]="usersDeclaimedStatistic"
      [teamLogoVisible]="false"
      identity="leaguePlayer"
      sort="points"
      order="desc"
    ></mtg-statistic-table>
  </div>
</div>

<mtg-tournament-team-staff
  *ngIf="users"
  title="Капитан и ассистенты"
  staffType="captains"
  [users]="users"
></mtg-tournament-team-staff>

<mtg-tournament-team-staff
  *ngIf="users"
  title="Руководство"
  staffType="leadership"
  [users]="users"
></mtg-tournament-team-staff>

<mtg-tournament-team-staff
  *ngIf="users"
  title="Тренерский состав"
  staffType="coach"
  [users]="users"
></mtg-tournament-team-staff>
<div class="section">
  <div class="title">Статистика в турнире</div>

  <div class="panel">
    <div class="statistic-title">Общая</div>
    <mtg-statistic-table
      *ngIf="teamStatistic"
      [statistic]="[teamStatistic]"
      [statisticHeader]="getStatisticHeader()"
    ></mtg-statistic-table>
    <mtg-spinner *ngIf="!teamStatistic"></mtg-spinner>

    <div class="statistic-title">По результатам игр</div>
    <mtg-statistic-table
      *ngIf="winLoseStatistic"
      subTitle="winLoses"
      [statistic]="winLoseStatistic"
      [statisticHeader]="getStatisticHeader()"
    ></mtg-statistic-table>
    <mtg-spinner *ngIf="!winLoseStatistic"></mtg-spinner>

    <div class="statistic-title">По месяцам</div>
    <mtg-statistic-table
      *ngIf="statisticByMonth"
      subTitle="month"
      [statistic]="statisticByMonth"
      [statisticHeader]="getStatisticHeader()"
    ></mtg-statistic-table>
    <mtg-spinner *ngIf="!statisticByMonth"></mtg-spinner>
  </div>
</div>


